forestControllers.controller('welcomeController', function ($scope, $state, $http, Server, dialogs, dropDownData, $q, _, notifications) {

    $scope.latest = $scope.latestClosed = $scope.displayedLatest = [];

    $scope.latest = [];

    console.log('latest: ', $scope.latest);

    $scope.chosen_items = [];

    Server.getUserList().then(function (list) {
        $scope.userList = list;
    });

    var servData = dropDownData;
    for (var d in servData) {
        if (servData.hasOwnProperty(d)) {
            $scope[d] = servData[d];
        }
    }

    $scope.getters = {
        min_max: function (value) {
            return value.tree_min_number + ' ' + value.tree_max_number;
        },
        martvis_organo: function (value) {

            var found = _.findWhere($scope.martvisOrganoebi, {id: value.martvis_organo_id});

            var label = found ? found.label : '';

            console.log('label: ', label);

            return found ? found.label : '';
        }
    };

    function getDocs() {

        Server.getLatest(1000).then(function (data) {
            $scope.latest = data;
        });

        //TODO: get closed docs too
        //$scope.latestClosed = something
    }

    getDocs();

    $scope.newForestCut = function () {
        $state.go('app.forest-cut');
    };

    $scope.duplicate = function (id) {
        Server.createPassportDublicate(id).then(function (id) {
            $state.go('app.forest-cut-edit', {edit: id});
        });
    };

    $scope.batchDelete = function () {

        dialogs.confirm('დასტური', 'დარწმუნებული ხართ რომ გინდათ წაშალოთ?').result.then(function(){

            notifications.showInfo('ტყეკაფები იშლება...');

            Server.deletePassportMany($scope.chosen_items).then(function(){
                notifications.closeAll();
                notifications.showSuccess({
                    message: 'ტყეკაფები წაიშალა',
                    hideDelay: 1500, //ms
                    hide: true //bool
                });
                getDocs();
            }).catch(function(){
                notifications.closeAll();
                notifications.showError('ტყეკაფები წაშლა ვერ მოხერხდა');
            });
        });
    };

    $scope.newSB = function () {
        $state.go('app.sataqsacio-barati');
    };

    $scope.edit = function (id) {
        $state.go('app.forest-cut-edit', {edit: id});
    };

    $scope.export = function (id) {

        Server.exportPassportDoc(id);

    };

    $scope.exportJoined = function () {
        var ids = $scope.chosen_items;
    };

    $scope.delete = function (id) {
        dialogs.confirm("დასტური", "დაადასტურეთ პასპორტის წაშლა").result.then(function () {
            Server.deletePassport(id).then(function () {
                getDocs();
            });
        });
    };

    $scope.dublicateForUser = function (user_id) {

        if (!user_id) {
            return;
        }

        Server.dublicatePassportsForUser($scope.chosen_items, user_id)
            .then(function () {
                /**
                 * Duplication succeed now we need to update owner of these passports.
                 */

                alert('Duplicates created');
                getDocs();

            }).catch(function () {
                alert('Duplicates failed');
            });
    };

    $scope.$watch(searchParam, search);

    function searchParam() {
        return $scope.searchParam;
    }

    var searchRequests = [];

    function search() {

        return;

        if ($scope.searchParam) {
            var promise = Server.searchDocs($scope.searchParam);

            searchRequests.push();

            promise.then(function (list) {

                $scope.latest = list;
            });


        } else {
            $scope.latest = $scope.latestKeep;
        }

    }

    /*
     function latestDocs(){ //Bolo tyekafebi (daumtavreblebi)

     $http.get('/api/passports/2/edit').then(function(res){

     dropDataReady = true;
     //first data is from angular responce object and second is our.
     var servData = res.data.data;
     for (var d in servData){
     //console.log(d);
     if (servData.hasOwnProperty(d)) {
     $scope[d] = servData[d];
     }
     }

     console.log(JSON.stringify($scope.created_at));
     });
     }




     latestDocs();*/

    $scope.getLabelById = function (array, id) {

        if (!array) {
            return "";
        }

        for (var i = 0; i < array.length; i++) {
            if (array[i].id == id) {
                return array[i].label;
            }
        }
    }
});